// extracted by mini-css-extract-plugin
module.exports = {"customInput":"Search_customInput__c8P6Y"};